import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import {
    AppAside,
    AppBreadcrumb,
    AppFooter,
    AppHeader,
    AppSidebar,
    AppSidebarFooter,
    AppSidebarForm,
    AppSidebarHeader,
    AppSidebarMinimizer,
    AppSidebarNav,
} from '@coreui/react';
import roleModule from '../../Routes/RouteLoader';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AuthActions from '../../Redux/AuthRedux';
import history from '../../Services/history';

class DefaultLayout extends Component {
    state = {
        role: JSON.parse(localStorage.getItem('role')),
        userId: JSON.parse(localStorage.getItem('user_uuid')),
    }
    componentWillMount = () => {
        // Dirty ass fuck hack to avoid falling into render without proper data
        if (!JSON.parse(localStorage.getItem('role'))){
            history.push('/login');
            return;
        }
        this.props.actions.auth.checkAuth();
    }
    componentDidUpdate = (prevProps) => {
        if (!prevProps.auth.logoutSuccess && this.props.auth.logoutSuccess) {
            this.props.history.push('/login');
        }
        if (this.props.auth.tokenValidated === false) {
            this.props.history.push('/login');
        }
    }
    onLogout = () => {
        this.props.actions.auth.logout();
    }
    onMyAccountClick = () => {
        history.push('/profile');
    }
    render() {
        const { routes, menu } = roleModule.load(this.state.role);
        if (!this.state.role){
            history.push('/login');
        }
        return (
            <div className="app">
                <AppHeader fixed>
                    <DefaultHeader
                        logout={this.onLogout}
                        onMyAccountClick={this.onMyAccountClick}
                    />
                </AppHeader>
                <div className="app-body">
                <AppSidebar fixed display="lg">
                    <AppSidebarHeader />
                    <AppSidebarForm />
                    <AppSidebarNav navConfig={menu} {...this.props} />
                    <AppSidebarFooter />
                    <AppSidebarMinimizer />
                </AppSidebar>
                <main className="main">
                    <AppBreadcrumb appRoutes={routes}/>
                    <Container fluid>
                        <Switch>
                            {routes.map((route, idx) => {
                                    return route.component ? (
                                        <Route
                                            key={idx}
                                            path={route.path}
                                            exact={route.exact}
                                            name={route.name}
                                            render={props => (
                                                <route.component {...props} />
                                            )}
                                        />
                                    )
                                    : (null);
                                },
                            )}
                            {/* La raíz entra directo al dashboard. */}
                            <Redirect exact from="/" to="/dashboard" />
                            <Redirect from="/" to="/error/not-found" />
                        </Switch>
                    </Container>
                </main>
                <AppAside fixed hidden>
                    <DefaultAside />
                </AppAside>
                </div>
                <AppFooter>
                    <DefaultFooter />
                </AppFooter>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    actions: {
        auth: bindActionCreators(AuthActions, dispatch),
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);


// WEBPACK FOOTER //
// ./src/Containers/DefaultLayout/DefaultLayout.js